module.exports = __webpack_public_path__ + "static/favicon-180-981d2113f9e9914ed2a1a7ea2620f615.png";